import { defineRule, configure } from 'vee-validate';
import { localize, setLocale } from '@vee-validate/i18n';
import * as rules from '@vee-validate/rules';

import pt from '@vee-validate/i18n/dist/locale/pt_BR.json';
import en from '@vee-validate/i18n/dist/locale/en.json';
import es from '@vee-validate/i18n/dist/locale/es.json';

export default defineNuxtPlugin(() => {
  Object.keys(rules).forEach((rule) => {
    if (typeof (rules as any)[rule] === 'function') {
      defineRule(rule, (rules as any)[rule]);
    }
  });

  configure({
    generateMessage: localize({ en, pt, es }),
  });

  setLocale('pt');
});

